import { StateContext } from '@ngxs/store';
import { ExhibitionStateModel } from '../exhibition.state';
import { ChangeSelectedSection } from '../exhibition.state.actions';

export const changeSelectedSection = (ctx: StateContext<ExhibitionStateModel>, action: ChangeSelectedSection) => {
    ctx.patchState({
        selectedSection: action.payload.selectedSection
    });
};
